<ag-grid-angular
class="ag-theme-alpine" 
style="height: 80vh; width: 84vw; margin-left: 6px;" 
[columnDefs]="columnDefs"
[defaultColDef]="defaultColDef"
[autoGroupColumnDef]="autoGroupColumnDef"
[groupDefaultExpanded]="groupDefaultExpanded"
[rowData]="rowData"
(gridReady)="onGridReady($event)"
></ag-grid-angular>